import React from 'react';
import Item from '../components/Item';
import ItemLoggedIn from '../components/ItemLoggedIn';
import { getActiveItems, getRegistrations } from '../service/ItemService';
import { getUserId, isUserAdmin } from '../service/UserService';
import ClipLoader from "react-spinners/ClipLoader";
import { withRouter } from 'react-router-dom';

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      items: [],
      isAdmin: false 
    }
  }

  componentDidMount(){
    getActiveItems().then(data => {
      //console.log("active items", data);
      this.setState({items: data},
        ()=>{
        
        if(this.props.loggedIn){
          const userId = getUserId();
          this.setState({isAdmin: isUserAdmin()});
          //console.log("userid", userId);
          getRegistrations().then(regs=>{
            let regsOfUser = regs.filter(r=>r.user_id === userId);
            let items = [...this.state.items];
            //console.log("registrations", regsOfUser);

            for(let item of items){
              //console.log("getting regs for item:" + item.id);
              let regsForItem = regsOfUser.filter(r=>r.item_id === item.id);
              //console.log("found regs:", regsForItem);
              let foundItemIndex = items.findIndex(i=>i.id === item.id);
              if(regsForItem.length === 1){
                let reg = regsForItem[0];
                let changedItem = {...items[foundItemIndex], ...reg};
                items[foundItemIndex] = changedItem;
              }
              else if(regsForItem.length > 1){
                //console.log("more found");
                let regsHaveStatus = regsForItem.filter(r=>r.status !== null && r.status !== 'Jóváhagyásra vár' && r.evaluation);
                //console.log("regsHaveStatus", regsHaveStatus);
                if(regsHaveStatus.length === 0){
                  let changedItem = {...items[foundItemIndex], ...regsForItem[0]};
                  items[foundItemIndex] = changedItem;
                }
                else if(regsHaveStatus.length > 0 ){
                  let regsAllApproved = regsForItem.filter(r=>r.status !== null && r.status === 'Jóváhagyva' && r.evaluation);
                  let regsAllDenied= regsForItem.filter(r=>r.status !== null && r.status === 'Elutasítva' && r.evaluation);
                  let changedItem = {...items[foundItemIndex], regs:regsForItem};
                  if(regsAllApproved.length === regsForItem.length)
                    changedItem = {...items[foundItemIndex], regs:regsForItem, ...regsForItem[0]};
                  if(regsAllDenied.length === regsForItem.length)
                    changedItem = {...items[foundItemIndex], regs:regsForItem, ...regsForItem[0]};
                  items[foundItemIndex] = changedItem;
                }
              }

            }

            this.setState({items});
          });
        }
      });
    });

  }

  register(){
    this.props.history.push("/regisztracio");
  }

  render() { 
    //console.log("home render", this.props.loggedIn);
    return ( 
      <div style={{paddingBottom:30}}>
        <div className="kwizda-home-panel" style={{display:(this.props.loggedIn?"none":"block")}}>
          <div className="kwizda-home-panel1">
          Hobbikertje van és nem hisz a bio módszerek és készítmények működésében? Szkeptikus a vegyszerek nélküli növényvédelemmel kapcsolatban? Kíváncsi a valós tapasztalatokra?
          Csatlakozzon hozzánk, próbálja ki a biológiai növényvédelem vívmányait, megoldásait és az erre nemesített növényeket!
          Érdemes jelentkezni „on garden” kísérleteinkre, mert ingyenesen tesztelheti a legjobb termékeinket és megoszthatja tapasztalatait másokkal. Amennyiben megfelel a követelményeknek és a szabályok szerint dokumentálja a kísérletet, akkor díjmentesen juthat termékeinkhez. Sőt még garantált ajándékokban is részesül!
          Győződjön meg a bio megoldások erejéről és adja tovább tapasztalatait!

          </div>
        </div>
        <div className="kwizda-page-title" style={{display:(!this.props.loggedIn?"none":"block")}}>
          Kísérlet kiválasztása
        </div>
        {(this.props.loggedIn)?
        <div className="kwizda-home-item-container">
          {this.state.items && this.state.items.map((itemObj, i)=> (
            <ItemLoggedIn key={i} item={itemObj} loggedIn={this.props.loggedIn}
              isAdmin={this.state.isAdmin} 
              ></ItemLoggedIn>
            )
          )
          }    
        </div>
        :
        <div className="kwizda-home-item-container">
          {this.state.items && this.state.items.map((itemObj, i)=> (
            <Item key={i} item={itemObj} loggedIn={this.props.loggedIn}
              isAdmin={this.state.isAdmin} 
              ></Item>
            )
          )
          }    
        </div>
        }
        <ClipLoader loading={this.state.items.length === 0} size={80} />
      </div>
     )
  }
}
 
export default withRouter(Home);
